export default __webpack_public_path__ + "static/media/Theme19.6185afcb.png";